'use client';

import { Container, Typography, Box, Button } from '@mui/material';
import Link from 'next/link';

// Prevent static generation
export const dynamic = 'force-dynamic';

export default function NotFound() {
  return (
    <Container maxWidth="sm">
      <Box sx={{ my: 4, textAlign: 'center' }}>
        <Typography variant="h4" component="h1" gutterBottom>
          404 - Page Not Found
        </Typography>
        <Typography variant="body1" color="text.secondary" gutterBottom>
          The page you are looking for does not exist.
        </Typography>
        <Box sx={{ mt: 3 }}>
          <Link href="/" passHref>
            <Button variant="contained" color="primary">
              Return Home
            </Button>
          </Link>
        </Box>
      </Box>
    </Container>
  );
} 